// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getLanguageFromCookie } from './utils/languageCookie';

const savedLng = getLanguageFromCookie();

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: savedLng || 'SRB',
    fallbackLng: 'SRB',
    debug: true,
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
    backend: {
      // Dodaj timestamp na svaki zahtev ka prevodu da izbegne keširanje
      loadPath: (lngs, namespaces) => {
        const timestamp = new Date().getTime();
        return `/locales/${lngs}/${namespaces}.json?t=${timestamp}`;
      },
    },
    detection: {
      order: [
        'querystring',
        'cookie',
        'localStorage',
        'navigator',
        'htmlTag',
        'path',
        'subdomain',
      ],
      caches: ['cookie'],
    },
  });

export default i18n;
